import { render } from "./Modal_View_Sevidores.vue?vue&type=template&id=7735da71"
import script from "./Modal_View_Sevidores.vue?vue&type=script&lang=js"
export * from "./Modal_View_Sevidores.vue?vue&type=script&lang=js"

import "./Modal_View_Sevidores.vue?vue&type=style&index=0&id=7735da71&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__